module.exports = __webpack_public_path__ + "img/transactions.e47bb070.png";